import { render, staticRenderFns } from "./HistoryBody.vue?vue&type=template&id=8a2ed22c&scoped=true&"
import script from "./HistoryBody.vue?vue&type=script&lang=ts&"
export * from "./HistoryBody.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryBody.vue?vue&type=style&index=0&id=8a2ed22c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2ed22c",
  null
  
)

export default component.exports